"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGridSpinsComponentsArray = void 0;
var _react = _interopRequireDefault(require("react"));
var _SpinCardWithSeparator = _interopRequireDefault(require("./SpinCardWithSeparator"));
var _SpinDetail = _interopRequireDefault(require("./SpinDetail"));
const getGridSpinsComponentsArray = ({
  filteredDomains,
  gridNumOfColumns,
  selectedSpinIndex,
  selectedDetailIndex,
  isRightSpinSelected,
  isLeftSpinSelected,
  CelebrateDetailView,
  PremiumDetailView,
  SpinInCartExpandedComponent,
  isSpinExpandable,
  hideDetailedViewExactMatch,
  ctaProps,
  options,
  onCardSpinClick,
  onExpandedSpinDataNotAvailable,
  cartContents,
  enableDynamicFontScaling,
  PriceBlock,
  language,
  AddToCartButton,
  CustomCartStateBadge
}) => {
  const cardSpinsArray = [];
  const detailSpacesLength = Math.ceil(filteredDomains.length / gridNumOfColumns) + 1;
  const remainder = filteredDomains.length % gridNumOfColumns;
  const emptySpacesLength = remainder > 0 ? gridNumOfColumns - remainder : 0;
  const length = filteredDomains.length + detailSpacesLength + emptySpacesLength;
  let spinIndex = 0;
  let spinDetailIndex = 0;
  const isClickable = options?.isClickable;
  for (let i = 1; i <= length; i++) {
    if ((i - 1) % (gridNumOfColumns + 1) === 0) {
      const selectedDomain = selectedSpinIndex > -1 ? filteredDomains[selectedSpinIndex] : filteredDomains[0];
      const showDetail = selectedDetailIndex === spinDetailIndex;
      selectedDomain && showDetail && isClickable && cardSpinsArray.push(/*#__PURE__*/_react.default.createElement(_SpinDetail.default, {
        key: `_${i}`,
        index: spinDetailIndex,
        selectedDomain: selectedDomain,
        selectedDetailIndex: selectedDetailIndex,
        selectedSpinIndex: selectedSpinIndex,
        isRightSpinSelected: isRightSpinSelected,
        isLeftSpinSelected: isLeftSpinSelected,
        CelebrateDetailView: CelebrateDetailView,
        PremiumDetailView: PremiumDetailView,
        SpinInCartExpandedComponent: SpinInCartExpandedComponent,
        isSpinExpandable: isSpinExpandable,
        hideDetailedViewExactMatch: hideDetailedViewExactMatch,
        onExpandedSpinDataNotAvailable: onExpandedSpinDataNotAvailable,
        cartContents: cartContents,
        gridNumOfColumns: gridNumOfColumns,
        onCardSpinClick: onCardSpinClick
      }));
      spinDetailIndex++;
    } else {
      const domain = filteredDomains[spinIndex];
      if (domain) {
        cardSpinsArray.push(/*#__PURE__*/_react.default.createElement(_SpinCardWithSeparator.default, {
          CustomCartStateBadge: CustomCartStateBadge,
          domain: domain,
          index: spinIndex,
          selectedSpinIndex: selectedSpinIndex,
          onCardSpinClick: onCardSpinClick,
          isRightSpinSelected: isRightSpinSelected,
          isLeftSpinSelected: isLeftSpinSelected,
          ctaProps: ctaProps,
          options: options,
          enableDynamicFontScaling: enableDynamicFontScaling,
          PriceBlock: PriceBlock,
          language: language,
          AddToCartButton: AddToCartButton
        }));
      } else {
        cardSpinsArray.push(/*#__PURE__*/_react.default.createElement("div", {
          key: `_${i}`,
          "data-testid": "grid-space"
        }));
      }
      spinIndex++;
    }
  }
  return cardSpinsArray;
};
exports.getGridSpinsComponentsArray = getGridSpinsComponentsArray;